import { Box, CardMedia, Skeleton, Stack } from "@mui/material";
import Text from "src/components/Displays/Text";
import {
  b2cMobileHouse,
  b2cMobileHouseLB,
  battery,
  eCarCharging,
  gridFeedIn,
  heatPumpConsumption,
  houseConsumption,
  lichtblickLogoMobile,
  LichtBlickLogoSMA,
  pvProduction,
} from "src/assets";
import PulseAnimation from "../Animation/PulseAnimation";
import { ThemeValues } from "../ThemeUsage/theme";

interface MobileViewProps {
  data: any;
  uuid: string;
  theme: string;
}

const MobileView = ({ uuid, data, theme }: MobileViewProps) => {
  const getBgImage = () => {
    if (theme === ThemeValues.lichtblick) {
      return b2cMobileHouseLB;
    }
    return b2cMobileHouse;
  };

  return (
    <>
      <Stack direction={"column"} alignItems={"center"} p={5}>
        <Text
          sx={(theme) => ({
            fontSize: "16px",
            fontWeight: "500",
            color: theme.palette.black.main,
          })}
          text={`B2C View Live Data`}
        />

        <LichtBlickLogoSMA />
      </Stack>

      <Box bgcolor="#F8F6F2" pt={6} pb={12}>
        <Box width="205px" height="70px">
          <CardMedia
            component="img"
            alt="pvProduction"
            image={lichtblickLogoMobile}
            sx={{ objectFit: "contain" }}
          />
        </Box>
      </Box>

      <Stack>
        <Box
          sx={{
            height: "152px",

            position: "relative",
            backgroundSize: "contain",
            backgroundPosition: "right",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url(${getBgImage()})`,
          }}
        >
          <Box
            sx={{
              top: "20px",
              left: "20px",
              float: "left",
              zIndex: "1000",
              position: "absolute",
            }}
          >
            <Stack gap={3}>
              <Stack direction={"row"} alignItems={"center"} gap={3}>
                <Text
                  sx={(theme) => ({
                    fontSize: "20px",
                    fontWeight: "500",
                    lineHeight: "24px",
                  })}
                  text={`Dein Zuhause`}
                />

                <PulseAnimation
                  sx={{
                    width: "10px",
                    height: "10px",
                    background: "#ffa137",
                  }}
                />

                <Text
                  sx={(theme) => ({
                    fontSize: "12px",
                    fontWeight: "500",
                    lineHeight: "24px",
                  })}
                  text={`online`}
                />
              </Stack>

              <Stack>
                <Text
                  sx={(theme) => ({
                    fontSize: "12px",
                    fontWeight: "400",
                    lineHeight: "15px",
                    letterSpacing: "0.02px",
                  })}
                  text={`Finde heraus \n wie viel Energie du \n produzierst, \n verbrauchst und ins \n Netz einspeist.`}
                />
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Stack>

      <Stack gap={2} p={5}>
        <Stack direction={"row"} gap={2}>
          <Box
            sx={{
              padding: 3,

              height: "100px",
              width: "100%",

              bgcolor: "#FBF7F3",
              borderRadius: "10px",
              border: "1px solid #FCC274",
            }}
          >
            <Stack height={"100%"}>
              <Text
                sx={(theme) => ({
                  color: "#262626",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                })}
                text={`PV Produktion`}
              />

              <Stack
                gap={2}
                height={"100%"}
                direction={"row"}
                alignItems={"center"}
              >
                <Box height="38px" width="38px">
                  <CardMedia
                    component="img"
                    alt="pvProduction"
                    image={pvProduction}
                    sx={{ objectFit: "contain" }}
                  />
                </Box>
                {!data && <Skeleton width={"65px"} variant="rounded" />}
                {data && (
                  <Text
                    sx={(theme) => ({
                      color: "#616161",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "20px",
                      letterSpacing: "0.02px",
                    })}
                    text={data.productionWatt + " W"}
                  />
                )}
              </Stack>
            </Stack>
          </Box>

          <Box
            sx={{
              padding: 3,

              height: "100px",
              width: "100%",

              borderRadius: "10px",
              border: "1px solid #64C294",
              bgcolor: "rgba(100, 194, 148, 0.15)",
            }}
          >
            <Stack height={"100%"}>
              <Text
                sx={(theme) => ({
                  color: "#262626",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                })}
                text={`Batterie`}
              />

              <Stack
                gap={2}
                height={"100%"}
                direction={"row"}
                alignItems={"center"}
              >
                <Box height="38px" width="38px">
                  <CardMedia
                    component="img"
                    alt="battery"
                    image={battery}
                    sx={{ objectFit: "contain" }}
                  />
                </Box>

                {!data && <Skeleton width={"65px"} variant="rounded" />}
                {data && (
                  <Stack>
                    <Text
                      sx={(theme) => ({
                        color: "#616161",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "20px",
                        letterSpacing: "0.02px",
                      })}
                      text={data.storageChargeWatt + " W"}
                    />

                    <Stack direction={"row"} gap={2}>
                      <PulseAnimation
                        sx={{
                          mt: "2px",
                          width: "7px",
                          height: "7px",
                          background: "#64C294",
                        }}
                      />
                      <Text
                        sx={(theme) => ({
                          color: "#616161",
                          fontSize: "10px",
                          fontWeight: "600",
                          lineHeight: "10px",
                          letterSpacing: "0.02px",
                        })}
                        text={"wird geladen"}
                      />
                    </Stack>
                  </Stack>
                )}
              </Stack>
            </Stack>
          </Box>
        </Stack>

        <Stack direction={"row"} gap={2}>
          <Box
            sx={{
              padding: 3,

              height: "100px",
              width: "100%",

              borderRadius: "10px",
              border: "1px solid #DB7923",
              bgcolor: "rgba(219, 121, 35, 0.15)",
            }}
          >
            <Stack height={"100%"}>
              <Text
                sx={(theme) => ({
                  color: "#262626",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                })}
                text={`Netzeinspeisung`}
              />

              <Stack
                gap={2}
                height={"100%"}
                direction={"row"}
                alignItems={"center"}
              >
                <Box height="38px" width="38px">
                  <CardMedia
                    component="img"
                    alt="gridFeedIn"
                    image={gridFeedIn}
                    sx={{ objectFit: "contain" }}
                  />
                </Box>

                {!data && <Skeleton width={"65px"} variant="rounded" />}

                {data && (
                  <Text
                    sx={(theme) => ({
                      color: "#616161",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "20px",
                      letterSpacing: "0.02px",
                    })}
                    text={data.gridFeedInWatt + " W"}
                  />
                )}
              </Stack>
            </Stack>
          </Box>

          <Box
            sx={{
              padding: 3,

              height: "100px",
              width: "100%",

              borderRadius: "10px",
              border: "1px solid #B9C7D8",
              bgcolor: "rgba(185, 199, 216, 0.15)",
            }}
          >
            <Stack height={"100%"}>
              <Text
                sx={(theme) => ({
                  color: "#262626",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                })}
                text={`Haus Verbrauch`}
              />

              <Stack
                gap={2}
                height={"100%"}
                direction={"row"}
                alignItems={"center"}
              >
                <Box height="38px" width="38px">
                  <CardMedia
                    component="img"
                    alt="houseConsumption"
                    image={houseConsumption}
                    sx={{ objectFit: "contain" }}
                  />
                </Box>
                {!data && <Skeleton width={"65px"} variant="rounded" />}

                {data && (
                  <Text
                    sx={(theme) => ({
                      color: "#616161",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "20px",
                      letterSpacing: "0.02px",
                    })}
                    text={data.consumptionHouseholdWatt + " W"}
                  />
                )}
              </Stack>
            </Stack>
          </Box>
        </Stack>

        <Stack direction={"row"} gap={2}>
          <Box
            sx={{
              padding: 3,

              height: "100px",
              width: "100%",

              borderRadius: "10px",
              border: "1px solid #539D77",
              bgcolor: "rgba(83, 157, 119, 0.15)",
            }}
          >
            <Stack height={"100%"}>
              <Text
                sx={(theme) => ({
                  color: "#262626",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                })}
                text={`E-Auto lädt`}
              />

              <Stack
                gap={2}
                height={"100%"}
                direction={"row"}
                alignItems={"center"}
              >
                <Box height="38px" width="38px">
                  <CardMedia
                    component="img"
                    alt="eCarCharging"
                    image={eCarCharging}
                    sx={{ objectFit: "contain" }}
                  />
                </Box>
                {!data && <Skeleton width={"65px"} variant="rounded" />}
                {data && (
                  <Text
                    sx={(theme) => ({
                      color: "#616161",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "20px",
                      letterSpacing: "0.02px",
                    })}
                    text={data.consumptionEvseWatt + " W"}
                  />
                )}
              </Stack>
            </Stack>
          </Box>

          <Box
            sx={{
              padding: 3,

              height: "100px",
              width: "100%",

              borderRadius: "10px",
              border: "1px solid #758EA5",
              bgcolor: "rgba(117, 142, 165, 0.15)",
            }}
          >
            <Stack height={"100%"}>
              <Text
                sx={(theme) => ({
                  color: "#262626",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "15px",
                  letterSpacing: "0.02px",
                })}
                text={`Wärmepumpe Verbrauch`}
              />

              <Stack
                gap={2}
                height={"100%"}
                direction={"row"}
                alignItems={"center"}
              >
                <Box height="38px" width="38px">
                  <CardMedia
                    component="img"
                    alt="heatPumpConsumption"
                    image={heatPumpConsumption}
                    sx={{ objectFit: "contain" }}
                  />
                </Box>

                {!data && <Skeleton width={"65px"} variant="rounded" />}

                {data && (
                  <Text
                    sx={(theme) => ({
                      color: "#616161",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "20px",
                      letterSpacing: "0.02px",
                    })}
                    text={data.consumptionHpWatt + " W"}
                  />
                )}
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Stack>

      <Box height={60} bgcolor="#F8F6F2"></Box>

      <Stack pt={5} px={10} pb={10} alignItems={"center"}>
        <Text
          sx={(theme) => ({
            fontSize: "16px",
            fontWeight: "500",
            color: theme.palette.black.main,
          })}
          text={`UUID: ${uuid}`}
        />
      </Stack>
    </>
  );
};

export default MobileView;
